import { IHeaderDropdownItems, IHeaderItems } from '../interface/headerItems';
import { DashboardTabEnum, ProfileTabEnum } from '../enum/dashboardTab';
import { TFunction } from 'i18next';
import { headerDropdownItemsEnum } from 'core/enum/header-dropdown';

const headerItems = (
  t: TFunction<'translation', undefined>
): IHeaderItems[] => {
  return [
    {
      title: t('About me'),
      isActive: true,
      value: DashboardTabEnum.ABOUT_ME
    },
    {
      title: t('Talent profile'),
      isActive: false,
      value: DashboardTabEnum.PREFERENCES
    },
    {
      title: t('Skills'),
      isActive: false,
      value: DashboardTabEnum.SKILLS
    },
    {
      title: t('Career and School'),
      isActive: false,
      value: DashboardTabEnum.EDUCATION_EXPERIENCE
    },
    {
      title: t('Personal Branding'),
      isActive: false,
      value: DashboardTabEnum.IMAGE_YOUTUBE
    }
  ];
};

const headerItemsProfile = (
  t: TFunction<'translation', undefined>
): IHeaderItems[] => {
  return [
    {
      title: t('About me'),
      isActive: true,
      value: ProfileTabEnum.ABOUT_ME
    },
    {
      title: t('Competency scores and Preferences'),
      isActive: false,
      value: ProfileTabEnum.COMPETENCY_SCORES
    },
    {
      title: t('Skills'),
      isActive: false,
      value: ProfileTabEnum.SKILLS
    },
    {
      title: t('Education and experience'),
      isActive: false,
      value: ProfileTabEnum.EDUCATION_EXPERIENCE
    },
    {
      title: t('Image and video'),
      isActive: false,
      value: ProfileTabEnum.IMAGE_YOUTUBE
    }
  ];
};

const headerDropdownItems = (
  t: TFunction<string, undefined>
): IHeaderDropdownItems[] => {
  return [
    {
      key: headerDropdownItemsEnum.SETTINGS,
      icon: 'settings.svg',
      title: t(headerDropdownItemsEnum.SETTINGS)
    },
    {
      key: headerDropdownItemsEnum.MEMBERSHIP,
      icon: 'member.svg',
      title: t(headerDropdownItemsEnum.MEMBERSHIP)
    },
    {
      key: headerDropdownItemsEnum.SIGN_OUT,
      icon: 'out.svg',
      title: t(headerDropdownItemsEnum.SIGN_OUT)
    },
    {
      key: headerDropdownItemsEnum.UPGRADE,
      icon: 'upgrade.svg',
      title: t(headerDropdownItemsEnum.UPGRADE)
    }
  ];
};

export { headerItems, headerDropdownItems, headerItemsProfile };
